import ReferencesList from './references-list';

export default class ReferencesListDesktop extends ReferencesList {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/references/list/references-list.desktop.js